import { jsx as a, Fragment as C, jsxs as s } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import O from "./logo.webp.js";
import y from "./menu-dropdown-wrapper-mobile.svg.js";
import A from "./burger.svg.js";
import G from "./close.svg.js";
import { useState as w, useCallback as m, useMemo as x } from "react";
import { AccountLink as S } from "./account-link/index.js";
import $ from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as H } from "./dropdown-menu-item/index.js";
import { useDisableScroll as D } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as R } from "../../../constants.js";
import { convertToKebabCase as T } from "../../../utils/case-conversion.js";
import { MobileAccountModalLink as q } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as B } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as v } from "./get-help-menu-item/index.js";
import { GradientButton as W } from "./gradient-button/index.js";
import { MenuChatButtonMobile as j } from "./chat-button/index.js";
import E from "./chevron-right-gradient.svg.js";
const ce = (t) => {
  const {
    isAuthenticated: c,
    openAuthModal: n,
    getTranslation: l,
    language: p,
    useWill: i,
    lmpEnabled: f,
    onRequestLawyer: d,
    hideLinks: M
  } = t, [r, o] = w(!1);
  D({ isDisabled: r });
  const L = m(() => {
    o(!0);
  }, []), h = m(() => {
    o(!1);
  }, []), u = m(() => {
    o(!1), c || n();
  }, [c, n]), g = m(() => {
    o(!1), t.logout();
  }, [t.logout]);
  return /* @__PURE__ */ a(C, { children: /* @__PURE__ */ s(
    "div",
    {
      className: `${e.menuModalOverlay} ${r ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ a(
          F,
          {
            isMenuOpen: r,
            closeMenu: h,
            openMenu: L,
            onAccountClick: u,
            handleLogout: g,
            isAuthenticated: t.isAuthenticated,
            userImage: t.userImage,
            hasNotifications: t.hasNotifications,
            language: p,
            getTranslation: l,
            isLawyerSupported: t.isLawyerSupported,
            onRequestLawyer: d,
            hideLinks: M,
            useWill: i
          }
        ),
        !M && /* @__PURE__ */ s(C, { children: [
          /* @__PURE__ */ a(
            K,
            {
              isAuthenticated: t.isAuthenticated,
              language: p,
              handleLogout: g,
              closeMenu: h,
              hasNotifications: t.hasNotifications,
              userImage: t.userImage,
              onAccountClick: u,
              getTranslation: l,
              isLawyerSupported: t.isLawyerSupported,
              onRequestLawyer: d,
              lmpEnabled: f,
              environment: t.environment
            }
          ),
          /* @__PURE__ */ a(y, { className: e.mobileBGIcon })
        ] })
      ]
    }
  ) });
}, F = (t) => {
  const {
    isMenuOpen: c,
    closeMenu: n,
    openMenu: l,
    onAccountClick: p,
    handleLogout: i,
    isAuthenticated: f,
    hasNotifications: d,
    userImage: M,
    language: r,
    getTranslation: o,
    isLawyerSupported: L,
    onRequestLawyer: h,
    hideLinks: u
  } = t, [g, N] = w(!1), k = m(() => {
    N(!0);
  }, []), b = m(() => {
    N(!1);
  }, []);
  return /* @__PURE__ */ s("div", { className: e.mobileMenuContainer, children: [
    !u && /* @__PURE__ */ a(
      "div",
      {
        className: e.menuIconContainer,
        onClick: c ? n : l,
        children: /* @__PURE__ */ s("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ a(
            "img",
            {
              src: A,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${c ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ a(
            "img",
            {
              src: G,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${c ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a(
      "a",
      {
        href: r ? `/${r}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: O,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    !u && (f ? /* @__PURE__ */ a(
      S,
      {
        isAuthenticated: f,
        userImage: M,
        openAuthModal: p,
        logout: i,
        hasNotifications: d,
        closeMenuModal: n,
        language: r,
        getTranslation: o
      }
    ) : L ? /* @__PURE__ */ s(C, { children: [
      /* @__PURE__ */ a(
        W,
        {
          label: o("pages.get-help"),
          onClick: k,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ a(
        v,
        {
          language: r || "en",
          titleLabel: o("pages.get-help"),
          getTranslation: o,
          isLawyerSupported: L,
          onRequestLawyer: h,
          closeMenu: b,
          externalIsOpen: g,
          externalOnOpen: k,
          externalOnClose: b,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ a(j, { getTranslation: o }))
  ] });
}, K = (t) => {
  const {
    handleLogout: c,
    language: n,
    closeMenu: l,
    onAccountClick: p,
    getTranslation: i,
    isLawyerSupported: f,
    lmpEnabled: d,
    onRequestLawyer: M,
    useWill: r,
    environment: o
  } = t, [L, h] = w(!1), u = m(() => {
    h(!0);
  }, []), g = m(() => {
    h(!1);
  }, []), N = x(() => {
    var b;
    const k = (b = R[n]) == null ? void 0 : b.map((I) => ({
      ...I,
      path: `/${n}/topics/${T(I.title)}`
    }));
    return k || null;
  }, [n]);
  return /* @__PURE__ */ s("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: u,
          children: [
            /* @__PURE__ */ a("div", { className: e.gradientTextContent, children: i("pages.get-help") }),
            /* @__PURE__ */ a(E, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ a(
        v,
        {
          language: n,
          titleLabel: i("pages.get-help"),
          getTranslation: i,
          isLawyerSupported: f,
          onRequestLawyer: M,
          closeMenu: g,
          externalIsOpen: L,
          externalOnOpen: u,
          externalOnClose: g,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      d ? /* @__PURE__ */ s("a", { href: n ? `/${n}/find` : "/find", className: e.mainMenuLink, onClick: l, children: [
        "Browse lawyers",
        /* @__PURE__ */ a($, { className: e.arrowIcon })
      ] }) : null,
      N && /* @__PURE__ */ a(
        H,
        {
          language: n,
          titleLabel: i("pages.legal-topics"),
          link: `/${n}/topics`,
          items: N,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      d ? null : /* @__PURE__ */ a(
        "a",
        {
          href: `/${n}/about/company`,
          className: e.mainMenuLink,
          onClick: l,
          children: i("pages.about")
        }
      ),
      /* @__PURE__ */ a(
        B,
        {
          language: n,
          getTranslation: i,
          useWill: r,
          environment: o,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      t.isAuthenticated ? /* @__PURE__ */ a(
        q,
        {
          language: n,
          handleLogout: c,
          userImage: t.userImage,
          hasNotifications: t.hasNotifications,
          getTranslation: i
        }
      ) : /* @__PURE__ */ s("div", { className: e.mainMenuLink, onClick: p, children: [
        i("pages.account"),
        /* @__PURE__ */ a($, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: l,
          children: i("pages.insights")
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: l,
          children: i("pages.faqs")
        }
      ),
      N && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: l,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: l,
          children: i("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  ce as MobileMenu
};
